export const MATCH_PARAMS = {
  FIRST_NAME: 'talent.firstName',
  FULL_NAME: 'talent.fullName',
  JOB_TITLE: 'talent.currentJob.jobTitle',
  STATUS: 'status',
  ENGAGEMENT_STATUS: 'engagement.status',
  CREATED_AT: 'createdAt',
};

export const POSITION_PARAMS = {
  JOB_TITLE: 'jobTitle',
  ACCOUNT_ID: 'accountId',
  ACCOUNT_NAME: 'accountName',
  CITY: 'location.city',
  MATCHES: 'numberOfMatches',
  STATUS: 'status',
  STATE: 'state',
  UPDATE_AT: 'updatedAt',
  CREATED_AT: 'createdAt',
};

export const POSITION_OVERVIEW_PARAMS = {
  JOB_TITLE: 'jobTitle',
  ACCOUNT_ID: 'accountId',
  ACCOUNT_NAME: 'account.accountName',
  PLAN: 'account.plan',
  ACCEPTANCE: 'matchesOverview.acceptance',
  PUBLISHED: 'matchesOverview.published',
  TO_REVIEW: 'matchesOverview.toReview',
  APPROVED: 'matchesOverview.approved',
  DECLINED: 'matchesOverview.declined',
  CONTACTED: 'outreachStatistics.contacted',
  REPLIED: 'outreachStatistics.repliedConversations',
  LAST_PUBLISHED: 'matchesOverview.lastPublishedAt',
  UPDATE_AT: 'updatedAt',
  CREATED_AT: 'createdAt',
};

export const TALENT_PARAMS = {
  FULL_NAME: 'fullName',
  CURRENT_COMPANY_ID: 'currentJob.companyId',
  CURRENT_COMPANY_NAME: 'currentJob.companyName',
  CURRENT_JOB_TITLE: 'currentJob.jobTitle',
  DATE_UPDATED: 'updatedAt',
  DATE_CREATED: 'createdAt',
  LINKEDIN_URL: 'linkedinUrl',
  TALENT_ID: 'talentId',
};

export const ACCOUNT_PARAMS = {
  DISPLAY_NAME: 'displayName',
  PLAN: 'plan',
  ASSOCIATED_COMPANY: 'associatedCompany',
  SUBDOMAIN: 'subDomainName',
  STATUS: 'accountStatus',
  POSITIONS: 'positions',
  EMAIL_SENDERS: 'emailSenders',
  ATS: 'ats',
  DATE_UPDATED: 'updatedAt',
  DATE_CREATED: 'createdAt',
  ACCOUNT_ID: 'id',
};

export const ACCOUNT_KEY_SHORTCUTS_PARAMS = {
  SUBDOMAIN: 'subdomain',
};
